import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetricState } from './MetricTypes';
// import { fetchUserGeoLocation } from './metric-geo-operations';

// const initGeoLocation = { region: 'unknown', city: 'unknown' };

const initialState: MetricState = {
  // geoLocation: initGeoLocation,
  sessionId: null,
  lastSeen: null,
  guestId: null,
  firstTimePages: {},
};

const metricSlice = createSlice({
  name: 'metric',
  initialState,
  reducers: {
    // setGeoLocation: (state, action: PayloadAction<GeoLocation>) => {
    //   state.geoLocation = action.payload;
    // },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
    setLastSeen: (state, action: PayloadAction<number>) => {
      state.lastSeen = action.payload;
    },
    setGuestId: (state, action: PayloadAction<string | null>) => {
      state.guestId = action.payload;
    },
    markPageAsVisited: (state, action: PayloadAction<string>) => {
      state.firstTimePages[action.payload] = false;
    },
  },
  // extraReducers: builder => {
  //   builder.addCase(fetchUserGeoLocation.fulfilled, (state, { payload }) => {
  //     state.geoLocation = payload;
  //   });
  //   builder.addCase(fetchUserGeoLocation.rejected, state => {
  //     state.geoLocation = initGeoLocation;
  //   });
  // },
});

export const { setSessionId, setLastSeen, setGuestId, markPageAsVisited } = metricSlice.actions;
export default metricSlice.reducer;
